module.exports = __webpack_public_path__ + "img/general.4558080e.jpg";